import { z } from 'zod';

export const folderSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  parentId: z.string().uuid().nullable(),
  clientId: z.string().uuid().nullable().optional(),
  name: z.string().min(1).max(255),
  path: z.string(),
  color: z.string().nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Folder = z.infer<typeof folderSchema>;

export const folderPublicSchema = folderSchema.omit({
  userId: true,
});

export type FolderPublic = z.infer<typeof folderPublicSchema>;

export const createFolderRequestSchema = z.object({
  name: z.string().min(1).max(255),
  parentId: z.string().uuid().nullable().optional(),
  color: z.string().optional(),
  projectId: z.string().uuid().optional(),
  clientId: z.string().uuid().optional(),
});

export type CreateFolderRequest = z.infer<typeof createFolderRequestSchema>;

export const updateFolderRequestSchema = z.object({
  name: z.string().min(1).max(255).optional(),
  parentId: z.string().uuid().nullable().optional(),
  color: z.string().nullable().optional(),
});

export type UpdateFolderRequest = z.infer<typeof updateFolderRequestSchema>;

export const breadcrumbItemSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export type BreadcrumbItem = z.infer<typeof breadcrumbItemSchema>;
